<template>
  <div>
    <clipboard-modal
      :show="modals.clipboard"
      @copy="copyEmailsToClipboard"
      @cancel="closeModalClipboard"
    >
      <div class="scrollable">{{ emailsToCopy }}</div>
    </clipboard-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          :fetch-data="fetchPeople"
          :create-allowed="isPowerUserOrAdministrator"
          title="Personnes"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom" min-width="20" property="lastName" />
          <el-table-column label="Prénom" min-width="20" property="firstName" />
          <el-table-column label="Institution(s)" min-width="60">
            <div slot-scope="slotScope">
              <div v-if="slotScope.row.personInstitutions.length > 0">
                <div
                  v-for="personInstitution in slotScope.row.personInstitutions"
                  :key="personInstitution.institutionName"
                  class="institution"
                >
                  {{ personInstitution.institutionName }}
                </div>
              </div>
              <div v-else>-</div>
            </div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
    <button
      :disabled="isEmailsExporting"
      :class="{ 'btn-export-not-connected': !isPowerUserOrAdministrator }"
      type="primary"
      class="btn btn-primary btn-fill btn-wd btn-export-emails"
      @click.prevent="exportAllEmailsToTxtButtonClicked"
    >
      Adresses E-mail Prof
    </button>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import swal from 'sweetalert2';
import CrudList from './CrudList.vue';
import ClipboardModal from './ClipboardModal.vue';

export default {
  components: {
    CrudList,
    ClipboardModal,
  },
  data() {
    return {
      modals: {
        clipboard: false,
      },
      searchText: '',
      emailsToCopy: '',
      isEmailsExporting: false,
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  created() {
    if (this.$route.params && this.$route.params.searchText) {
      this.searchText = this.$route.params.searchText;
    }
  },
  methods: {
    showSwal(type) {
      if (type === 'basic-email-copy-success') {
        swal({
          title: 'Succès',
          text:
            'Les adresses e-mail professionelles ont été copiées dans le presse-papier',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success',
        });
      } else if (type === 'basic-email-copy-failure') {
        swal({
          title: 'Erreur',
          text: 'Impossible de copier dans le presse-papier',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'error',
        });
      }
    },
    closeModalClipboard() {
      this.emailsToCopy = '';
      this.modals.clipboard = false;
    },
    copyEmailsToClipboard() {
      const dummyTextToCopy = document.createElement('input');
      document.body.appendChild(dummyTextToCopy);
      dummyTextToCopy.setAttribute('value', this.emailsToCopy);
      dummyTextToCopy.select();
      const successful = document.execCommand('copy');

      if (successful) {
        this.showSwal('basic-email-copy-success');
      } else {
        this.showSwal('basic-email-copy-failure');
      }
      document.body.removeChild(dummyTextToCopy);
      this.closeModalClipboard();
    },
    exportAllEmailsToTxtButtonClicked() {
      this.isEmailsExporting = true;

      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/txt/private/allprofemails`,
          {
            headers: {
              Accept: 'text/plain',
            },
          },
        )
        .then(response => {
          this.isEmailsExporting = false;
          this.emailsToCopy = response.data;
          this.modals.clipboard = true;
        })
        .catch(error => {
          this.isEmailsExporting = false;
        });
    },
    rowClicked(row) {
      this.$router.push({
        name: 'PersonDetails',
        params: { id: row.id, newPersonCreation: false },
      });
    },
    fetchPeople(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;

      // If a searchText is defined within the component (coming from the route parameter in created method), fetch peoples corresponding to that text
      if (this.searchText) {
        // eslint-disable-next-line no-param-reassign
        searchText = this.searchText;
        // Reset component's searchText
        this.searchText = '';
      }
      if (searchText) {
        url += `/search/persons?searchTerm=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/personEntities?projection=personListDTO&sort=lastName&page=${pageNumber -
          1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.personEntities
          ? response.data._embedded.personEntities
          : [],
        page: response.data.page,
      }));
    },
    create() {
      this.$router.push({
        name: 'PersonDetails',
        params: { id: 0, newPersonCreation: true },
      });
    },
  },
};
</script>

<style scoped>
.scrollable {
  overflow: auto;
  height: 300px;
}

.btn-export-emails {
  position: absolute;
  right: 110px;
  top: 102px;
  margin: 0px;
}

.institution:not(:first-child) {
  margin-top: 0.5em;
}

.btn-export-not-connected {
  right: 39px;
}
</style>
